<template>
  <div class="dashboard">
    <div>
      <p class="color-gray">Acá podrás observar el historial de utilización de tus pases.</p>
    </div>
    <SearchInput v-model="searchVal" :shortcutIcon="false" />
    <PasesUtilizados :pasesUtilizados="pasesFiltrados" />
    <Button class="mt-20" type="button" text="Volver" classtype="back" @click="goToDashboard" />
  </div>
</template>
<script setup>
import { onMounted, ref, computed } from "vue"
import { usePasesStore, useClasesStore } from "@/store"
import { goToDashboard } from "@/helpers/"
import PasesUtilizados from "../components/PasesUtilizados.vue"
import Button from "../components/Button.vue"
import SearchInput from "../components/SearchInput.vue"

const pasesStore = usePasesStore()
const clasesStore = useClasesStore()

pasesStore.cleanPaseSelected()

onMounted(() => {
  pasesStore.getUserPases().then(() => {
    clasesStore.getClases(pasesStore.arrayIdActividadesPases)
  })
})

const searchVal = ref("")

const pasesFiltrados = computed(() => {
  if (searchVal.value == "") {
    return pasesStore.pasesUtilizados
  }
  return pasesStore.pasesUtilizados.filter((p) => {
    return (
      p.actividad.toLowerCase().includes(searchVal.value.toLocaleLowerCase()) ||
      p.fechaUX.includes(searchVal.value) ||
      p.hora.includes(searchVal.value)
    )
  })
})
</script>
<style>
.dashboard {
  text-align: left;
  display: flex;
  flex-direction: column;
  padding: 0 28px;
  max-width: 360px;
  gap: 20px;
}

.user {
  font-size: 1.5rem;
}
@media (min-width: 720px) {
  .dashboard {
    max-width: 640px;
  }
}
</style>
